// extracted by mini-css-extract-plugin
export default {"scrollToSite":"vr7fFADH","stick":"thQtn5Tz","scrolled":"ceEnIVXK","stickLink":"e74Qr_qZ","body":"WkevV3dX","title":"rcvCvfJn","screenlink":"Fyrfs5R5","overlay":"VMcNgVEh"};